<template>
  <div class="preview-container">
    <div class="fuckPartyA">该预览与App展示效果略有出入,仅供参考,真实效果以App为主</div>
    <div class="preview">
      <img
        src="../../../assets/app/img_app_config_preview.png"
        class="bg_preview"
      />
      <img src="../../../assets/app/img_tab_bar.png" class="tab_bar" />
      <div class="container">
        <div class="search">
          <img
            src="../../../assets/app/img_app_search.png"
            class="img_search"
          />
        </div>
        <div class="display">
          <!-- 横向滚动导航 -->
          <div class="nav-container">
            <div class="nav-list">
              <div class="nav-item nav-item_active">推荐</div>
              <Skeleton
                class="skeleton nav-item"
                v-for="(item, idx) of navList"
                :key="idx"
              />
            </div>
          </div>

          <!-- 轮播图 -->
          <div class="carousel">
            <ElCarousel height="100px" indicator-position="none" arrow="never">
              <ElCarouselItem v-for="(item, idx) in carouselList" :key="idx">
                <Skeleton class="carousel_skeleton" />
              </ElCarouselItem>
            </ElCarousel>
          </div>

          <!-- 固定展示模块一 -->
          <div class="fixed_one">
            <div class="title">
              <Skeleton class="fixed_title" />
            </div>
            <div class="content_one_container">
              <div class="content_one">
                <SkeletonCard
                  class="skeleton_fixed_one"
                  v-for="(item, idx) of fixedModuleOne"
                  :key="item + '_' + idx"
                >
                  <template v-slot:image>
                    <Skeleton
                      class="skeleton-paragraph skeleton_fixed_one_image"
                    />
                  </template>
                  <template v-slot:desc>
                    <Skeleton
                      class="skeleton-paragraph skeleton_fixed_one_desc"
                    />
                  </template>
                </SkeletonCard>
              </div>
            </div>
          </div>

          <!-- 固定展示模块二 -->
          <div class="fixed_two">
            <div class="title">
              <Skeleton class="fixed_title" />
            </div>
            <div class="content_two">
              <SkeletonCard
                class="fixed_two_item"
                v-for="(item, idx) of fixedModuleTwo"
                :key="item + '_' + idx"
              >
                <template v-slot:image>
                  <div class="image_two skeleton-paragraph">
                  </div>
                </template>
                <template v-slot:desc>
                  <div class="desc_two skeleton-paragraph" />
                </template>
              </SkeletonCard>
            </div>
          </div>

          <!-- 配置模块 -->
          <div class="ad-container">
            <div class="ad-list">
              <div class="ad-item" v-for="(item, idx) of adList" :key="idx">
                <div class="ad-title">
                  <div class="ad-name">{{ item.regionTitle }}</div>
                  <div class="look-more">
                    <span>打开</span>
                    <img
                      src="../../../assets/app/icon_more.png"
                      class="icon_more"
                    />
                  </div>
                </div>
                <div class="ad-content">
                  <AdCardList :adList="item.configList" :mode="item._mode" />
                </div>
              </div>
            </div>
          </div>

          <!-- 其他模块 -->
          <div class="fixed_last">
            <div class="title">
              <Skeleton class="fixed_title" />
            </div>
            <div class="content_two">
              <SkeletonCard
                class="fixed_two_item"
                v-for="(item, idx) of fixedModuleLast"
                :key="item + '_' + idx"
              >
                <template v-slot:image>
                  <div class="image_two skeleton-paragraph">
                  </div>
                </template>
                <template v-slot:desc>
                  <div class="desc_two skeleton-paragraph" />
                </template>
              </SkeletonCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, CarouselItem } from "element-ui";

import Skeleton from "./skeleton";
import SkeletonCard from "./card";
import AdCardList from "./ad-card-list";

import { queryPreivew } from "../api";

export default {
  name: "PartPreview",

  parent: "Part",

  props: {
    showPreview: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },

  data() {
    return {
      navList: [],
      carouselList: [],
      fixedModuleOne: [],
      fixedModuleTwo: [],
      adList: [],
      fixedModuleLast: []
    };
  },

  watch: {
    showPreview: {
      handler(newVal) {
        if (newVal) {
          this.getPreivew();
        }
      },
      immediate: true
    }
  },

  components: {
    Skeleton: Skeleton,
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem,
    SkeletonCard: SkeletonCard,
    AdCardList: AdCardList
  },

  created() {
    // 初始化数据
    this.navList = this.initNavList();
    this.carouselList = this.initCarouselList();
    this.fixedModuleOne = this.initFixedModuleOne();
    this.fixedModuleTwo = this.initFixedModuleTwo();
    this.fixedModuleLast = this.initFixedModuleLast();
  },

  methods: {
    // 接口请求

    getPreivew() {
      queryPreivew()
        .then(res => {
          this.adList = [...res];
        })
        .catch(_ => _);
    },

    //
    initNavList() {
      return new Array(10).fill("Nav");
    },

    initCarouselList() {
      return new Array(5).fill("Carousel");
    },

    initFixedModuleOne() {
      return new Array(5).fill("fixedOne");
    },

    initFixedModuleTwo() {
      return new Array(6).fill("fixedTwo");
    },

    initFixedModuleLast() {
      return new Array(4).fill("fixedLast");
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-container {
  width: 100%;
  height: 690px;
  .fuckPartyA {
    color: #ff0000;
    text-align: center;
  }
  .preview {
    position: relative;
    height: 690px;
    overflow: hidden;
    .bg_preview {
      position: absolute;
      top: 0;
      left: 0;
      margin: auto;
      width: 400px;
    }
    .tab_bar {
      position: absolute;
      bottom: 64px;
      left: 50%;
      width: 270px;
      transform: translateX(-50%);
      border-radius: 0 0 20px 20px;
      z-index: 10;
    }
    .container {
      position: absolute;
      top: 60px;
      left: 50%;
      margin: auto;
      box-sizing: border-box;
      width: 270px;
      height: 520px;
      transform: translateX(-50%);
      .display {
        padding: 0px 15px;
        height: 93%;
        overflow-y: scroll;
      }
      .display::-webkit-scrollbar {
        display: none;
      }
      .search {
        overflow: hidden;
        width: 270px;
        .img_search {
          width: 270px;
        }
      }
      .nav-container {
        width: 240px;
        overflow-x: hidden;
      }
      .nav-list {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        overflow-x: scroll;
        .nav-item {
          display: flex;
          align-items: center;
          margin-right: 10px;
          height: 30px;
          min-width: 50px;
        }
        .nav-item:last-child {
          margin-right: 0;
        }
        .skeleton {
          margin-right: 10px;
          width: 50px;
          height: 30px;
        }
        .nav-item_active {
          font-size: 18px;
          font-weight: 600;
          color: #2540ac;
        }
      }
      .nav-list::-webkit-scrollbar {
        display: none;
      }
      .carousel {
        margin-top: 15px;
        width: 100%;
        .carousel_skeleton {
          width: 100%;
          height: 100px;
          border-radius: 10px;
        }
      }
      .fixed_one,
      .fixed_two {
        margin-top: 15px;
      }
      .fixed_one {
        .content_one_container {
          width: 240px;
          overflow-x: hidden;
        }
        .content_one {
          display: flex;
          margin-top: 5px;
          width: 100%;
          overflow-x: scroll;
          .skeleton_fixed_one {
            display: flex;
            flex-direction: column;
            margin-right: 10px;
            width: 100px;
          }
          .skeleton_fixed_one_image {
            width: 100px;
            height: 60px;
            border-radius: 6px;
          }
          .skeleton_fixed_one_desc {
            margin-top: 5px;
            width: 100px;
            height: 30px;
            border-radius: 4px;
          }
        }
        .content_one::-webkit-scrollbar {
          display: none;
        }
      }
      .fixed_two {
        .content_two {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 5px;
          width: 240px;
          .fixed_two_item {
            margin-bottom: 5px;
            .image_two {
              width: 117px;
              height: 70px;
              border-radius: 6px;
            }
            .desc_two {
              width: 117px;
              margin-top: 5px;
              height: 30px;
              border-radius: 4px;
            }
          }
        }
      }
      .fixed_last {
        margin-top: 10px;
        .content_two {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 5px;
          width: 240px;
          .fixed_two_item {
            margin-bottom: 5px;
            .image_two {
              width: 117px;
              height: 70px;
              border-radius: 6px;
            }
            .desc_two {
              width: 117px;
              margin-top: 5px;
              height: 30px;
              border-radius: 4px;
            }
          }
        }
      }
      .title {
        width: 240px;
        height: 30px;
        .fixed_title {
          width: 240px;
          height: 30px;
        }
      }
      .ad-container {
        .ad-list {
          .ad-item {
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            .ad-title {
              display: flex;
              align-items: center;
              height: 50px;
              .ad-name {
                max-width: 180px;
                word-break: keep-all;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 16px;
                font-weight: 500;
                color: #494949;
                overflow: hidden;
              }
              .look-more {
                display: flex;
                align-items: center;
                margin-left: auto;
                .icon_more {
                  margin-left: 6px;
                  width: 10px;
                  height: 16px;
                }
              }
            }
          }
          .ad-item:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
